import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, deleteToken, onMessage } from "firebase/messaging"; // ← added deleteToken

const firebaseConfig = {
  apiKey: "AIzaSyAgn68hGELUa_CMSKz6JXo0SOsrohikJbA",
  authDomain: "elite-goats-sheeps.firebaseapp.com",
  projectId: "elite-goats-sheeps",
  storageBucket: "elite-goats-sheeps.firebasestorage.app",
  messagingSenderId: "239215201011",
  appId: "1:239215201011:web:489d1195b9dd891bf5c586",
  measurementId: "G-9S9H3LRZ9L"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const isWebSupported = typeof Notification !== 'undefined' && 'serviceWorker' in navigator;
const messaging = isWebSupported ? getMessaging(app) : null;

export const requestNotificationPermission = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("❌ Notification permission denied.");
      return null;
    }

    console.log("✅ Notification permission granted.");

    // ✅ Clear cached stale token, then fetch a fresh one
    try {
      await deleteToken(messaging);
    } catch (_) {
      // No existing token to delete — fine, continue
    }

    const token = await getToken(messaging, {
      vapidKey: "BJEiCT_jqQuNqzzqXe_EI4gvB6JHfig7L5WvjqRy07wGNbzq1bt0XE44DdWD0Hg5rzFXuFFJkmBUxNtPhVARG5E"
    });

    if (token) {
      console.log("📱 FCM Token:", token);
      return token;
    } else {
      console.log("No registration token available.");
      return null;
    }

  } catch (error) {
    console.error("Error getting notification permission:", error);
    return null;
  }
};

export const onForegroundMessage = (callback) => {
  return onMessage(messaging, (payload) => {
    console.log("📩 Message received in foreground:", payload);
    callback(payload);
  });
};

export { app, analytics, messaging };